import "../.././styles/Constitution.css";

function ArticleFive() {
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE V: OFFICERS AND THEIR ACCOUNTABILITIES</h3>
                    <h5>5.1 Officers and Primary Duties</h5>
                    <p>
                        At its first meeting following each Annual General Meeting, Members of the Governing
                        Board shall meet and choose from among themselves the following Officers for the ensuing
                        calendar year:
                    </p>
                    <ol type="I">
                        <li><p>
                            <b>President</b>
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                Supervise the affairs of the Corporation and the Governing Board;
                            </p></li>
                            <li><p>
                                Preside at all meetings of the Corporation and the Governing Board;
                            </p></li>
                            <li><p>
                                May convene a special Governing Board meeting at the written request of any ten
                                (10) of the fifteen (15) members of the Governing Board;
                            </p></li>
                            <li><p>
                                Coordinate various input from Members of the Governing Board, and committees in
                                completing an Annual Report to the General Membership;
                            </p></li>
                            <li><p>
                                Be an ex-officio member of all committees of the Governing Board;
                            </p></li>
                            <li><p>
                                Ensure that press or news releases of the corporation are reviewed and consistent
                                with instructions from the Governing Board or within the guiding principles and
                                objectives of the corporation;
                            </p></li>
                            <li><p>
                                Act as the authorized representative of the corporation in attending meetings or
                                invitations, and liaising with Filipino organized groups, government departments or
                                agencies, and other organizations; and
                            </p></li>
                            <li><p>
                                One of two authorized signing officers of the corporation, the Treasurer or Assistant
                                Treasurer the other.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Vice President</b>
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                Perform the functions of the President in his or her absence if the President is
                                unable to fulfill his or her duties and responsibilities; and
                            </p></li>
                            <li><p>
                                Perform such other duties as assigned by the Governing Board.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Secretary</b>
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                Record &amp; maintain minutes of all meetings of the Corporation and of the Governing
                                Board, and ensure that the minutes are signed by the Chairperson within a
                                reasonable period of time after each meeting;
                            </p></li>
                            <li><p>
                                Issue notices of meetings of the Corporation and the Governing Board;
                            </p></li>
                            <li><p>
                                Record the names of those present at each meeting of the Corporation and of the
                                Governing Board;
                            </p></li>
                            <li><p>
                                Monitor in maintaining custody of all the records and documents of the
                                Corporation, except those required to be kept by the Treasurer;
                            </p></li>
                            <li><p>
                                Ensure appropriate use &amp;custody of the corporate logo &amp; seal of the Corporation;
                            </p></li>
                            <li><p>
                                Ensure that Registry or Membership data base of the Corporation are kept current
                                used solely for the interest of the corporation;
                            </p></li>
                            <li><p>
                                Monitor and summarize all incoming mails to the corporation, which are reported at
                                the next scheduled board meeting;
                            </p></li>
                            <li><p>
                                Record the names of those present at each meeting of the Corporation and of the
                                Governing Board; and
                            </p></li>
                            <li><p>
                                Perform such other duties assigned by the Governing Board.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Treasurer</b>
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                One of two other authorized signing officers of the corporation, the Assistant
                                Treasurer being the other;
                            </p></li>
                            <li><p>
                                Supervise proper receipts of all funds received by the corporation and manage bank
                                accounts of the Corporation;
                            </p></li>
                            <li><p>
                                Ensure that financial records, including books of accounts are maintained at all
                                times, as are necessary to accurately represent the true financial state of the
                                Corporation;
                            </p></li>
                            <li><p>
                                Deposit all funds of the Corporation in one or more accounts in the name of the
                                Corporation at one or more financial institutions, as determined by the Governing
                                Board;
                            </p></li>
                            <li><p>
                                Ensure prudent and proper documentations of disbursements of funds of the
                                Corporation;
                            </p></li>
                            <li><p>
                                Provide Monthly Financial Statements, including Income Statement, Cash Flow
                                Statement, and Balance Sheet and Monthly Summary of Cash Receipts and
                                Disbursements at each meeting of the Corporation; and
                            </p></li>
                            <li><p>
                                Perform such other duties as assigned by the Governing Board.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Assistant Treasurer</b>
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                One of two other authorized signing officers of the corporation, the Treasurer being
                                the other;
                            </p></li>
                            <li><p>
                                Shall assist the members of the Programs &amp; Services Committee in managing
                                financial needs related to fundraising programs and events;
                            </p></li>
                            <li><p>
                                Perform all the duties and responsibilities of the Treasurer in her or his absence; and
                            </p></li>
                            <li><p>
                                Perform such other duties as assigned by the Governing Board.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Auditor</b>
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                Analyze &amp; report, on a regular basis, the Corporation’s prudent cash management,
                                analysis of reported receipts and disbursements, with focus on legitimacy of
                                exceptional or non-recurring items;
                            </p></li>
                            <li><p>
                                Monitor and ensure that books of accounts and financial reporting systems are
                                current;
                            </p></li>
                            <li><p>
                                Analyze, on a timely basis, all activities and financial reports of the Governing Board,
                                and to report any findings that needs attention of the Governing Board or General
                                Membership;
                            </p></li>
                            <li><p>
                                Initiate and recommends policies &amp; procedures that may deter improper use of
                                monetary and physical assets of the corporation;
                            </p></li>
                            <li><p>
                                Recommends the appointment or engagement of External Auditors, as may be
                                required &amp; directed by the Governing Board; and
                            </p></li>
                            <li><p>
                                Perform such other duties as assigned by the Governing Board.
                            </p></li>
                        </ol>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>5.2 Indemnity</h5>
                    <p>
                        Subject to the provisions of any relevant law, no Member of the Governing Board of the
                        corporation shall be liable for the acts, receipts, neglects or defaults of any other member or
                        office bearer, or for any loss, damage or expense suffered by the corporation, which occurs in
                        the execution of his or her duties, unless it arises as a result of his or her dishonesty, or failure
                        to exercise the degree of care, diligence and skill required by law.
                    </p>
                </div>
            </div>
        </>
    );
}

export default ArticleFive;